import service from '../../utils/Service';

const setBranchHostPermission =  (eventId) => {
   return {
      type: 'SET_BRANCH_HOST_PERMISSION',
      payload: service.branchHostPermission(eventId),
   }
}

export default setBranchHostPermission;



// WEBPACK FOOTER //
// ./src/actions/events/setBranchHostPermissionAction.js